import React, { Component } from 'react';
import './Career.css';
import CareerService from '../../services/CareerService/CareerService';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import Loader from '../../components/Loader/Loader';
import NotFound from '../NotFound/NotFound';

class CareerDetail extends Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.state = {
      job: null,
      is_loader: true,
      fields: {},
      errors: {},
      resume: null,
      cover_letter: null,
      isSubmit: 0,
      successMsg: '',
      apiError: '',
    };
  }

  scrollToMessage = () => {
    if (this.messageRef.current) {
      this.messageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      fields: { ...this.state.fields, [name]: value },
      errors: { ...this.state.errors, [name]: '' }, // clear field error
      successMsg: '',
      apiError: '',
    });
  };

  // handleChange = (e) => {
  //     const { placeholder, value } = e.target;

  //     let keyMap = {
  //         "Enter first name*": "first_name",
  //         "Enter last name*": "last_name",
  //         "Enter email": "email",
  //         "Enter phone number": "phone_number",
  //         "Additional Comments": "note"
  //     };

  //     const field = keyMap[placeholder];

  //     if (field) {
  //         this.setState({
  //             fields: { ...this.state.fields, [field]: value },
  //             errors: { ...this.state.errors, [field]: "" }, // clear field error
  //             successMsg: "", // clear success on typing
  //             apiError: "" // clear api error
  //         });
  //     }
  // };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;

    this.setState({
      [name]: file,
    });
  };
  validate = () => {
    let err = {};
    const { fields, resume, cover_letter, job } = this.state;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9()\-\s]+$/;

    if (!fields.first_name || !fields.first_name.trim()) {
      err.first_name = 'First name is required';
    }

    if (!fields.last_name || !fields.last_name.trim()) {
      err.last_name = 'Last name is required';
    }

    if (!fields.email || !fields.email.trim()) {
      err.email = 'Email is required';
    } else if (!emailRegex.test(fields.email)) {
      err.email = 'Enter valid email';
    }

    if (!fields.phone_number || !fields.phone_number.trim()) {
      err.phone_number = 'Phone number is required';
    } else if (!phoneRegex.test(fields.phone_number)) {
      err.phone_number = 'Only numbers, (), -, space allowed';
    }

    // if (!resume) {
    //   err.resume = 'Resume is required';
    // }
    if (job.application_requirements === 'resume' && !resume) {
      err.resume = 'Resume is required';
    }

    if (job.application_requirements === 'cover_letter_resume') {
      if (!resume) err.resume = 'Resume is required';
      if (!cover_letter) err.cover_letter = 'Cover letter is required';
    }

    return err;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      successMsg: '',
      apiError: '',
    });
    const errors = this.validate();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors: {}, isSubmit: 1, apiError: '', successMsg: '' });

    try {
      const { fields, resume,cover_letter, job } = this.state;

      let formData = new FormData();
      formData.append('first_name', fields.first_name);
      formData.append('last_name', fields.last_name);
      formData.append('email', fields.email);
      formData.append('phone_number', fields.phone_number);
      formData.append('position', job.title);
      formData.append('note', fields.note || '');
      //   formData.append('resume', resume);
      formData.append('job_id', job.id);
      if (
        job.application_requirements === 'resume' ||
        job.application_requirements === 'cover_letter_resume'
      ) {
        if (resume) formData.append('resume', resume);
      }

      if (job.application_requirements === 'cover_letter_resume') {
        if (cover_letter) formData.append('cover_letter', cover_letter);
      }
      const res = await CareerService.submitJobApplication(formData);

      if (res?.data?.status === 'success') {
        this.setState(
          {
            successMsg: 'Application submitted successfully!',
            fields: {},
            resume: null,
            errors: {},
            apiError: '',
          },
          this.scrollToMessage
        );
      } else {
        this.setState(
          {
            apiError: res?.data?.message || 'Something went wrong',
          },
          this.scrollToMessage
        );
      }
    } catch (err) {
      console.error(err);
      this.setState(
        { apiError: 'Server error. Try again later.' },
        this.scrollToMessage
      );
    } finally {
      this.setState({ isSubmit: 0 });
    }
  };

  componentDidMount() {
    const { jobId } = this.props.match.params;

    this.fetchJobDetail(jobId);
  }

  fetchJobDetail = async (slug) => {
    this.setState({ is_loader: true });

    try {
      const response = await CareerService.getJobDetail(slug);

      if (response?.data?.status === 'success') {
        this.setState({ job: response.data.result });
      } else {
        this.setState({ job: null });
      }
    } catch (error) {
      console.error('Error fetching job detail:', error);
      this.setState({ job: null });
    } finally {
      this.setState({ is_loader: false });
    }
  };

  render() {
    const { job, is_loader } = this.state;

    if (is_loader) {
      return (
        <main className="techtop-middle-div" id="techtop-jobs-details-section">
          <section className="py-70">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-center align-items-center">
                    <GearSpinner />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      );
    }

    if (!job) {
      return <NotFound />;
      //  <h2>Job not found</h2>;
    }

    return (
      <div>
        <main className="techtop-middle-div" id="techtop-jobs-details-section">
          <section className="hero jobs-bg">
            <div className="container">
              <div className="hero-content">
                <h1>{job.title}</h1>

                <p>
                  {job.department} • {job.employment_type} • {job.location}
                </p>
              </div>
            </div>
          </section>

          <section className="py-70">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                      <i className="fas fa-angle-right"></i>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/careers/">Careers</a>
                      <i className="fas fa-angle-right"></i>
                    </li>
                    <li className="breadcrumb-item active">{job.title}</li>
                  </ol>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-7 col-md-7 col-lg-8 col-xl-8">
                  <div className="infoBox">
                    <h2>Job Description</h2>
                    <p>{job.description}</p>
                  </div>

                  <div className="infoBox">
                    <h2>Responsibilities</h2>
                    <ul>
                      {job.responsibilities?.split('\n').map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="infoBox">
                    <h2>Requirements</h2>
                    <ul>
                      {job.qualifications?.split('\n').map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  {job.benefits && (
                    <div className="infoBox">
                      <h2>Benefits</h2>
                      <p>{job.benefits}</p>
                    </div>
                  )}

                  {job.travel_requirements && (
                    <div className="infoBox">
                      <h2>Travel Requirements</h2>
                      <p>{job.travel_requirements}</p>
                    </div>
                  )}

                  {job.salary && (
                    <div className="infoBox">
                      <h2>Salary</h2>
                      <p>{job.salary}</p>
                    </div>
                  )}
                </div>

                <div className="col-sm-5 col-md-5 col-lg-4 col-xl-4">
                  {this.state.isSubmit === 1 && (
                    <div className="text-center mb-3">
                      <Loader isLoading={true} message="Submitting..." />
                    </div>
                  )}
                  <form className="apply-form" onSubmit={this.handleSubmit}>
                    <div ref={this.messageRef}>
                      {this.state.successMsg && (
                        <div className="alert alert-success">
                          {this.state.successMsg}
                        </div>
                      )}
                      {this.state.apiError && (
                        <div className="alert alert-danger">
                          {this.state.apiError}
                        </div>
                      )}
                    </div>

                    <h2>Apply for this Job</h2>

                    <div className="mb-3">
                      <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        placeholder="Enter first name*"
                        value={this.state.fields.first_name || ''}
                        onChange={this.handleChange}
                      />
                      {this.state.errors.first_name && (
                        <div className="text-danger">
                          {this.state.errors.first_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        placeholder="Enter last name*"
                        value={this.state.fields.last_name || ''}
                        onChange={this.handleChange}
                      />
                      {this.state.errors.last_name && (
                        <div className="text-danger">
                          {this.state.errors.last_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter email*"
                        value={this.state.fields.email || ''}
                        onChange={this.handleChange}
                      />
                      {this.state.errors.email && (
                        <div className="text-danger">
                          {this.state.errors.email}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <input
                        type="text"
                        name="phone_number"
                        className="form-control"
                        placeholder="Enter phone number*"
                        value={this.state.fields.phone_number || ''}
                        onChange={(e) => {
                          if (/^[0-9()\-\s]*$/.test(e.target.value)) {
                            this.handleChange(e);
                          }
                        }}
                      />
                      {this.state.errors.phone_number && (
                        <div className="text-danger">
                          {this.state.errors.phone_number}
                        </div>
                      )}
                    </div>

                    <input
                      type="text"
                      className="form-control mb-3"
                      value={job.title}
                      readOnly
                    />

                    {/* <div class="col-md-12">
                      <div class="mb-3">
                        <label class="upload-box">
                          <span class="upload-text">
                            {this.state.resume
                              ? this.state.resume.name
                              : 'Upload resume here (PDF or DOCX)*'}
                          </span>
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            key={
                              this.state.resume
                                ? this.state.resume.name
                                : 'empty'
                            }
                            onChange={this.handleFileChange}
                          />
                        </label>
                        {this.state.errors.resume && (
                          <div className="text-danger">
                            {this.state.errors.resume}
                          </div>
                        )}
                      </div>
                    </div> */}
                    {/* Resume */}
                    {(job.application_requirements === 'resume' ||
                      job.application_requirements ===
                        'cover_letter_resume') && (
                      <div className="mb-3">
                        <label className="upload-box">
                          <span className="upload-text">
                            {this.state.resume
                              ? this.state.resume.name
                              : 'Upload resume (PDF or DOCX)*'}
                          </span>
                          <input
                            type="file"
                            name="resume"
                            accept=".pdf,.doc,.docx"
                            onChange={this.handleFileChange}
                          />
                        </label>
                        {this.state.errors.resume && (
                          <div className="text-danger">
                            {this.state.errors.resume}
                          </div>
                        )}
                      </div>
                    )}
                    {job.application_requirements === 'cover_letter_resume' && (
                      <div className="mb-3">
                        <label className="upload-box">
                          <span className="upload-text">
                            {this.state.cover_letter
                              ? this.state.cover_letter.name
                              : 'Upload cover letter (PDF or DOCX)*'}
                          </span>
                          <input
                            type="file"
                            name="cover_letter"
                            accept=".pdf,.doc,.docx"
                            onChange={this.handleFileChange}
                          />
                        </label>
                        {this.state.errors.cover_letter && (
                          <div className="text-danger">
                            {this.state.errors.cover_letter}
                          </div>
                        )}
                      </div>
                    )}

                    <textarea
                      className="form-control mb-3"
                      placeholder="Additional Comments"
                      name="note"
                      value={this.state.fields.note || ''}
                      onChange={this.handleChange}
                    />
                    <button
                      className="submit-btn"
                      disabled={this.state.isSubmit}
                    >
                      {this.state.isSubmit
                        ? 'Submitting...'
                        : 'Submit Application'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }
}

export default CareerDetail;